import * as React from "react";
import { Icon } from "./LandingIcons";

interface FAQItem {
  q: string;
  a: string;
}

const FAQ: FAQItem[] = [
  {
    q: "Is my data actually private, or just marketing-private?",
    a: "Both. All memory facts and voice conversations are end-to-end encrypted at rest, never used to train any model (yours or ours), and on self-host plans nothing leaves your network. We publish a privacy commitment with a financial penalty clause for violations.",
  },
  {
    q: "Which AI models does Omni run?",
    a: "Anthropic (Claude family), OpenAI (GPT-4/5 class), Google (Gemini), and any open-weight model you can run via Ollama or vLLM. Each agent picks its own model. The reasoning layer auto-routes by task class — or you pin one.",
  },
  {
    q: "How does the marketplace revenue split actually work?",
    a: "You set the price. We take 20%, you keep 80%. Net-30 payouts via Stripe Connect to 40+ countries. No hidden fees, no platform tax on free skills, no exclusivity. You can leave with your code and your customer list any time.",
  },
  {
    q: "Can I really run Omni on my own infrastructure?",
    a: "Yes. One `docker compose up` deploys the full stack: API, agents, vector DB, postgres, redis. Works on AWS, GCP, Azure, or bare metal. The self-host guide takes ~30 minutes. SSO with SAML/OIDC ships in the same binary.",
  },
  {
    q: "What happens when I hit a plan limit?",
    a: "You get a notification at 80%, another at 95%, and Omni keeps working past it for 7 days. You can upgrade, buy add-ons, or just wait for the cycle to reset. We never silently throttle or paywall mid-conversation.",
  },
  {
    q: "How is this different from ChatGPT, Claude.ai, or Gemini?",
    a: "Those are chat boxes around a model. Omni is the operating layer that wraps any model: persistent memory, multi-device sync, real voice calls, tool use through MCP, agent spawning, a marketplace, and a self-host story. The chat is one of nine surfaces, not the product.",
  },
];

export function FAQSection() {
  const [open, setOpen] = React.useState<number>(0);

  return (
    <section id="faq" className="section">
      <div className="container" style={{ maxWidth: 880 }}>
        <div className="section__head section__head--center">
          <div className="eyebrow eyebrow--accent">FAQ</div>
          <h2 className="section__title">The honest answers.</h2>
        </div>
        <div className="faq">
          {FAQ.map((item, i) => (
            <div
              key={item.q}
              className={`faq__item ${open === i ? "open" : ""}`}
            >
              <button
                className="faq__trigger"
                onClick={() => setOpen(open === i ? -1 : i)}
                aria-expanded={open === i}
              >
                <span>{item.q}</span>
                <span className="faq__chev">
                  <Icon name="plus" size={12} />
                </span>
              </button>
              <div className="faq__content">
                <div>
                  <div className="faq__answer">{item.a}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
